import React from "react";

interface ISignalRActionItemsContext {
  sendRefetchActionItem: (actionItemGuid: string) => void;
  sendRefetchUserStrategicOwnershipItems: (userGuid: string) => void;
  onShouldRefetchActionItem: (handler: (actionItemGuid: string) => void) => void;
  offShouldRefetchActionItem: (handler: (actionItemGuid: string) => void) => void;
  onShouldRefetchUserStrategicOwnershipItems: (handler: (userGuid: string) => void) => void;
  offShouldRefetchUserStrategicOwnershipItems: (handler: (userGuid: string) => void) => void;
}

const SignalRActionItemsContext = React.createContext<ISignalRActionItemsContext>({
  sendRefetchActionItem: () => null,
  sendRefetchUserStrategicOwnershipItems: () => null,
  onShouldRefetchActionItem: () => null,
  offShouldRefetchActionItem: () => null,
  onShouldRefetchUserStrategicOwnershipItems: () => null,
  offShouldRefetchUserStrategicOwnershipItems: () => null,
});

export { SignalRActionItemsContext };
